import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { getToken, removeToken } from '../../helpers';
import { apiGet, parseJsonResponse } from '../../api/apiClient';


const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(undefined);
  const [konfiguration, setKonfiguration] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const authToken = getToken();

  const handleInvalidSession = () => {
    removeToken();
    setUserData(undefined);
    setKonfiguration(undefined);
    navigate('/', { replace: true });
  };

  const fetchLoggedInUser = async (token) => {
    setIsLoading(true);
    try {
      const response = await apiGet('/users/me?populate=role');

      // Abgelaufener / ungültiger JWT → Token verwerfen und zurück zum Login,
      // sonst bleibt der User in einer kaputten Session hängen (leeres Dashboard).
      if (response.status === 401 || response.status === 403) {
        handleInvalidSession();
        return;
      }

      const data = await parseJsonResponse(response);

      if (data.data == null && data.error) {
        handleInvalidSession();
        return;
      }

      setUserData(data);

      const konfResponse = await apiGet('/konfigurations/1');
      if (konfResponse.status === 401 || konfResponse.status === 403) {
        handleInvalidSession();
        return;
      }
      const konfData = await parseJsonResponse(konfResponse);
      setKonfiguration(konfData.data.attributes);
    } catch (error) {
      console.error(error);
      // Fallback: Wenn die Fehlermeldung vom Backend auf eine Auth-Problematik
      // hindeutet, Session zurücksetzen statt den User im Limbo zu lassen.
      const msg = String(error?.message ?? '').toLowerCase();
      if (msg.includes('invalid credentials') || msg.includes('unauthorized') || msg.includes('forbidden')) {
        handleInvalidSession();
        message.error('Sitzung abgelaufen. Bitte erneut anmelden.');
        return;
      }
      message.error('Error While Getting Logged In User Details');
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    removeToken();
    setUserData(undefined);
    setKonfiguration(undefined);
    navigate('/', { replace: true });
  };

  useEffect(() => {
    if (authToken) fetchLoggedInUser(authToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);

  return (
    <AuthContext.Provider
      value={{
        user: userData,
        konfiguration,
        isLoading,
        setUser: setUserData,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

/**
 * @deprecated Nutze stattdessen useAuthContext().konfiguration
 * Wird für Abwärtskompatibilität beibehalten.
 */
export { AuthContext as UserKonfigurationContext };
